import './components'
import './validation'
import './directives'
import './tableWrapper'
import './scroll'


window.app = new Vue({
  el: '#app'
})



// WEBPACK FOOTER //
// ./src/js/main.js